function initStickyAddToCart() {
  document.querySelectorAll('[data-tsl-sticky-atc]').forEach((stickyBar) => {
    if (stickyBar.dataset.initialized === 'true') return;

    const addToCartButton = document.querySelector('[id^="ProductSubmitButton"]');
    if (!addToCartButton) {
      if (stickyBar.dataset.designMode === 'true') {
        const note = stickyBar.querySelector('[data-tsl-sticky-editor-note]');
        if (note) note.hidden = false;
      }
      return;
    }

    stickyBar.dataset.initialized = 'true';

    const stickyButton = stickyBar.querySelector('[data-tsl-sticky-button]');
    const stickyAddLabel = stickyButton?.dataset.addLabel || stickyButton?.textContent || '';
    const compareEl = stickyBar.querySelector('[data-tsl-sticky-compare]');
    const currentEl = stickyBar.querySelector('[data-tsl-sticky-current]');
    const variantEl = stickyBar.querySelector('[data-tsl-sticky-variant]');
    const imageWrap = stickyBar.querySelector('[data-tsl-sticky-image]');
    const optionSelects = stickyBar.querySelectorAll('[data-tsl-sticky-option-index]');

    const minScrollPercent = Number(stickyBar.dataset.minScrollPercent || 0);

    const setStickyHiddenState = (hidden) => {
      stickyBar.classList.toggle('tsl-sticky-atc--visible', !hidden);
      stickyBar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      if (hidden) {
        stickyBar.setAttribute('inert', '');
      } else {
        stickyBar.removeAttribute('inert');
      }
    };

    const syncVisibility = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const scrolledPercent = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 100;
      if (scrolledPercent < minScrollPercent) {
        setStickyHiddenState(true);
        return;
      }

      const cartOpen = Boolean(
        document.querySelector('cart-drawer.active, .cart-drawer.active, cart-drawer[open]')
      );
      if (cartOpen) {
        setStickyHiddenState(true);
        return;
      }

      const buttonRect = addToCartButton.getBoundingClientRect();
      const buttonVisible = buttonRect.top < window.innerHeight && buttonRect.bottom > 0;
      setStickyHiddenState(buttonVisible);
    };

    const onStickyClick = () => {
      if (stickyButton?.disabled) return;
      addToCartButton.click();
    };

    const syncOptionSelectsFromMain = () => {
      const productInfo = document.querySelector('product-info');
      if (!productInfo) return;

      optionSelects.forEach((select) => {
        const index = Number(select.dataset.tslStickyOptionIndex);
        const mainSelect = productInfo.querySelectorAll('variant-selects select')[index];
        if (mainSelect?.value) {
          select.value = mainSelect.value;
          return;
        }

        const checkedRadio = productInfo
          .querySelectorAll('variant-selects fieldset')
          [index]?.querySelector('input:checked');
        if (checkedRadio) select.value = checkedRadio.value;
      });
    };

    const onOptionChange = (event) => {
      const select = event.currentTarget;
      const index = Number(select.dataset.tslStickyOptionIndex);
      const productInfo = document.querySelector('product-info');
      if (!productInfo) return;

      const mainSelect = productInfo.querySelectorAll('variant-selects select')[index];
      if (mainSelect) {
        mainSelect.value = select.value;
        mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const fieldset = productInfo.querySelectorAll('variant-selects fieldset')[index];
      const radio = Array.from(fieldset?.querySelectorAll('input') || []).find(
        (input) => input.value === select.value
      );
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        radio.click();
      }
    };

    const updateFromVariantChange = (event) => {
      const { html, variant, sectionId } = event.data || {};
      if (!variant) return;

      if (variantEl) {
        variantEl.textContent = variant.title || '';
      }

      const priceRoot = html?.getElementById(`price-${sectionId}`) || html?.querySelector(`#price-${sectionId}`);
      if (priceRoot && (currentEl || compareEl)) {
        const sale = priceRoot.querySelector('.price-item--sale');
        const regular = priceRoot.querySelector('.price-item--regular');

        if (currentEl) {
          currentEl.textContent = (sale || regular)?.textContent?.trim() || currentEl.textContent;
        }

        if (compareEl) {
          const hasCompare = Boolean(sale && regular && priceRoot.querySelector('.price--on-sale'));
          if (hasCompare) {
            compareEl.textContent = regular.textContent.trim();
            compareEl.classList.remove('hidden');
          } else {
            compareEl.textContent = '';
            compareEl.classList.add('hidden');
          }
        }
      }

      if (imageWrap && html) {
        const mediaId = variant.featured_media?.id;
        let sourceImage = null;
        if (mediaId) {
          sourceImage = html.querySelector(`[data-media-id="${sectionId}-${mediaId}"] img`);
        }
        if (!sourceImage) {
          sourceImage = html.querySelector('.product__media-item.is-active img, .product__media img');
        }
        const existing = imageWrap.querySelector('img');
        if (sourceImage && existing) {
          existing.src = sourceImage.currentSrc || sourceImage.src;
          if (sourceImage.srcset) existing.srcset = sourceImage.srcset;
          if (sourceImage.sizes) existing.sizes = sourceImage.sizes;
        }
      }

      if (stickyButton) {
        const submitFromHtml = html?.querySelector('[id^="ProductSubmitButton"]');
        const unavailable = submitFromHtml?.hasAttribute('disabled') || variant.available === false;
        stickyButton.disabled = Boolean(unavailable);
        stickyButton.textContent = unavailable
          ? window.variantStrings?.soldOut || stickyButton.textContent
          : stickyAddLabel || window.variantStrings?.addToCart || stickyButton.textContent;
      }

      syncOptionSelectsFromMain();
    };

    let intersectionObserver;
    if ('IntersectionObserver' in window) {
      intersectionObserver = new IntersectionObserver(
        () => {
          syncVisibility();
        },
        { root: null, threshold: [0, 0.01, 1] }
      );
      intersectionObserver.observe(addToCartButton);
    } else {
      window.addEventListener('scroll', syncVisibility, { passive: true });
    }

    window.addEventListener('resize', syncVisibility, { passive: true });
    if (minScrollPercent > 0) {
      window.addEventListener('scroll', syncVisibility, { passive: true });
    }
    stickyButton?.addEventListener('click', onStickyClick);
    optionSelects.forEach((select) => select.addEventListener('change', onOptionChange));

    let unsubscribeVariantChange;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, updateFromVariantChange);
    }

    const cartDrawer = document.querySelector('cart-drawer');
    let cartObserver;
    if (cartDrawer && 'MutationObserver' in window) {
      cartObserver = new MutationObserver(syncVisibility);
      cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class', 'open'] });
      const cartDetails = cartDrawer.querySelector('#CartDrawer, details');
      if (cartDetails) {
        cartObserver.observe(cartDetails, { attributes: true, attributeFilter: ['open', 'class'] });
      }
    }

    stickyBar._tslStickyCleanup = () => {
      intersectionObserver?.disconnect();
      cartObserver?.disconnect();
      window.removeEventListener('scroll', syncVisibility);
      window.removeEventListener('resize', syncVisibility);
      stickyButton?.removeEventListener('click', onStickyClick);
      optionSelects.forEach((select) => select.removeEventListener('change', onOptionChange));
      if (typeof unsubscribeVariantChange === 'function') unsubscribeVariantChange();
      delete stickyBar.dataset.initialized;
      delete stickyBar._tslStickyCleanup;
    };

    setStickyHiddenState(true);
    syncVisibility();
  });
}

function destroyStickyAddToCart(scope = document) {
  scope.querySelectorAll?.('[data-tsl-sticky-atc]')?.forEach((stickyBar) => {
    stickyBar._tslStickyCleanup?.();
  });

  if (scope?.matches?.('[data-tsl-sticky-atc]')) {
    scope._tslStickyCleanup?.();
  }
}

document.addEventListener('DOMContentLoaded', initStickyAddToCart);
document.addEventListener('shopify:section:load', (event) => {
  destroyStickyAddToCart(event.target);
  initStickyAddToCart();
});
document.addEventListener('shopify:section:unload', (event) => {
  destroyStickyAddToCart(event.target);
});
